import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

export default function Terms() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 py-20">
        <div className="label-sm mb-3">Legal</div>
        <h1 className="font-display text-4xl sm:text-5xl">Terms & Conditions</h1>
        <p className="text-zinc-500 text-sm mt-2">Effective date: 25 Aug 2025 · Traders Spring Group</p>

        <div className="card-tech rounded-lg p-5 mt-8">
          <p className="text-sm text-zinc-400">
            <strong className="text-white">Summary:</strong> We run a proprietary trading evaluation program using Deriv MT5 demo accounts.
            We are independent and not affiliated with Deriv. All payouts are processed directly by Traders Spring Group.
          </p>
        </div>

        <div className="mt-10 space-y-8 text-zinc-300 leading-relaxed text-sm">
          <Section n="1" t="Nature of Service">
            Traders Spring Group ("TSG", "we", "us") provides proprietary trading evaluations and simulated performance accounts for traders of synthetic indices.
            All trading occurs on Deriv MT5 demo accounts that mirror live market conditions. These are simulated accounts; no orders are routed to live markets.
            Performance rewards are paid directly by TSG based on adherence to program rules.
          </Section>
          <Section n="2" t="Eligibility">
            <ul className="list-disc pl-5 space-y-1 marker:text-[#00ff66]">
              <li>You confirm you are at least 18 years old and permitted to use such services in your country.</li>
              <li>You will not use the service from any jurisdiction where prop-trading programs are restricted.</li>
            </ul>
          </Section>
          <Section n="3" t="Program Rules">
            You must follow the rules posted on our website (drawdowns, profit targets, minimum trading days, and consistency).
            See the <a href="/rules" className="text-[#00ff66] hover:underline">Rules page</a> for full details.
          </Section>
          <Section n="4" t="Fees & Refunds">
            <ul className="list-disc pl-5 space-y-1 marker:text-[#00ff66]">
              <li>Evaluation fees are one-time and <strong className="text-white">non-refundable</strong> once credentials are issued.</li>
              <li>We do not charge per-trade or per-lot commissions. Network/payment fees are borne by the user.</li>
            </ul>
          </Section>
          <Section n="5" t="Payouts">
            <ul className="list-disc pl-5 space-y-1 marker:text-[#00ff66]">
              <li>Payouts are processed in cryptocurrency.</li>
              <li>Processed 14 days from first trade on funded account for Core and Global.</li>
              <li>Processed 21 days from first trade on funded account for Instant Plan and Split Fee Model.</li>
              <li>Standard review window: 24–72 hours upon request.</li>
              <li>Standard processing window: 24–48 hours after approval.</li>
            </ul>
          </Section>
          <Section n="6" t="Prohibited Conduct">
            <ul className="list-disc pl-5 space-y-1 marker:text-[#00ff66]">
              <li>Use of HFT, latency arbitrage, tick manipulation, toxic flow, or any strategy exploiting platform inefficiencies.</li>
              <li>Group trading, coordinated trading, or copying trades from restricted or external sources.</li>
              <li>Multi-account abuse, including mirrored or correlated trading across accounts.</li>
              <li>Trading on behalf of others, sharing accounts, or using false or multiple identities. All accounts must be operated solely by the registered user.</li>
              <li>Any attempt to exploit demo infrastructure or system weaknesses.</li>
              <li>Fraudulent activities, including chargeback abuse or identity misrepresentation.</li>
            </ul>
          </Section>
          <Section n="7" t="Account Actions">
            We may suspend or terminate access for rule breaches or suspected abuse. You may purchase a new challenge after a failed evaluation.
          </Section>
          <Section n="8" t="Intellectual Property">
            All site content, logos, and materials are owned by Traders Spring Group. You may not copy, modify, or redistribute without written consent.
          </Section>
          <Section n="9" t="Disclaimers">
            <ul className="list-disc pl-5 space-y-1 marker:text-[#00ff66]">
              <li>Traders Spring Group is <strong className="text-white">not a broker</strong> and has <strong className="text-white">no official affiliation</strong> with Deriv.</li>
              <li>Nothing on this site is financial advice. Trading synthetic indices is risky even in simulations.</li>
              <li>Services are provided "as is"; we disclaim warranties to the fullest extent permitted by law.</li>
            </ul>
          </Section>
          <Section n="10" t="Changes">
            We may update these Terms at any time. Continued use after changes constitutes acceptance.
          </Section>
            <Section n="11" t="Integrity & Misconduct">
              Traders Spring Group expects all traders to act in good faith throughout the evaluation, funding, payout, and investigation process.

Any conduct intended to abuse our systems, interfere with our operations, harass our staff, or knowingly make false or misleading public statements that damage the Firm's reputation may constitute misconduct.

This includes, but is not limited to:

            <ul className="list-disc pl-5 space-y-1 marker:text-[#00ff66]">
              <li>Exploiting platform or system vulnerabilities.</li>
              <li>Harassing or abusing staff or community members.</li>
              <li>Knowingly making false or misleading public accusations.</li>
              <li>Interfering with or refusing to cooperate during investigations.</li>
              <li>Coordinating or encouraging actions intended to harm the Firm or its community.</li>
              
            </ul>

            Where we reasonably determine that misconduct has occurred, we reserve the right to suspend or terminate accounts, reject pending payouts, permanently prohibit access to our services, and remove the individual from our community platforms.
          </Section>
          <Section n="12" t="Governing Law & Jurisdiction">
            These Terms are governed by the laws of <strong className="text-white">St. Vincent & The Grenadines</strong>. Disputes shall be resolved exclusively in its courts.
          </Section>
          <Section n="13" t="Contact">
            Email: <a href="mailto:support@tradersspringfunding.com" className="text-[#00ff66] hover:underline">support@tradersspringfunding.com</a>
          </Section>
        </div>
        <p className="mt-12 text-xs text-zinc-600">© Traders Spring Group. All rights reserved.</p>
      </main>
      <Footer />
    </div>
  );
}

function Section({ n, t, children }) {
  return (
    <div>
      <h2 className="font-display text-xl text-white">{n}. {t}</h2>
      <div className="mt-2 text-zinc-400">{children}</div>
    </div>
  );
}
